import createUrlWithParams from 'helpers/createUrlWithParams';

import METHOD from '../_methods';

import { MembersEndpoint } from './_types';

const endpoint = '/api/v1/members/';
const endpointForRoleCatalog = '/api/v1/role_catalog/';

const members: MembersEndpoint = {
  getMember: id => ({ url: `${endpoint}${id}/`, method: METHOD.GET }),
  getRoleCatalog: () => ({ url: endpointForRoleCatalog, method: METHOD.GET }),
  search: params => ({ url: createUrlWithParams(endpoint, params), method: METHOD.GET }),
};

export default members;
